import React, { useState } from 'react';
import { MapPinIcon, FilterIcon, CompassIcon, ListIcon } from 'lucide-react';
import GlassCard from '../ui/GlassCard';
import Button from '../ui/Button';
const SodaLocator: React.FC = () => {
  const [viewMode, setViewMode] = useState<'map' | 'list'>('list');
  const locations = [{
    id: 1,
    name: 'Eco Café',
    address: '123 Green St',
    distance: '0.3 mi',
    isOpen: true,
    hasFreeRefills: true,
    flavors: ['Original', 'Berry', 'Citrus'],
    specialOffer: 'Get 20% off any meal with your Smart Soda purchase'
  }, {
    id: 2,
    name: 'Fitness Center',
    address: '45 Health Ave',
    distance: '0.7 mi',
    isOpen: true,
    hasFreeRefills: false,
    flavors: ['Original', 'Cucumber'],
    specialOffer: 'Free 7-day gym pass with 5 Smart Soda refills'
  }, {
    id: 3,
    name: 'Hydration Lounge at One Health Clubs',
    address: '789 Wellness Blvd',
    distance: '0.5 mi',
    isOpen: true,
    hasFreeRefills: true,
    flavors: ['Original', 'Berry', 'Mint', 'Citrus', 'Energy Boost'],
    specialOffer: 'Community meetups every Thursday 5-7PM',
    isFeatured: true
  }, {
    id: 4,
    name: 'Green Hotel',
    address: '789 Eco Blvd',
    distance: '1.2 mi',
    isOpen: false,
    hasFreeRefills: true,
    flavors: ['Original', 'Berry', 'Mint', 'Citrus'],
    specialOffer: '15% off at our signature restaurant'
  }];
  return <div className="h-full bg-[#1A237E] pt-12 pb-24 px-4 overflow-y-auto" data-id="element-1323">
      <header className="mb-6" data-id="element-1324">
        <h1 className="text-2xl font-bold text-white font-gt-ultra" data-id="element-1325">
          Smart Soda Locator
        </h1>
        <p className="text-[#00E4BB] font-gill-sans" data-id="element-1326">Find fountains near you</p>
      </header>
      {/* Search and filter */}
      <div className="flex items-center space-x-2 mb-4" data-id="element-1327">
        <div className="flex-1 relative" data-id="element-1328">
          <input type="text" placeholder="Search locations..." className="w-full bg-[#FAFAFA]/10 border border-[#00E4BB]/30 rounded-full px-4 py-3 pl-10 text-white focus:outline-none focus:ring-2 focus:ring-[#00E4BB]" data-id="element-1329" />
          <MapPinIcon className="absolute left-3 top-3.5 w-5 h-5 text-[#00E4BB]" data-id="element-1330" />
        </div>
        <button className="w-12 h-12 bg-[#FAFAFA]/10 border border-[#00E4BB]/30 rounded-full flex items-center justify-center" data-id="element-1331">
          <FilterIcon className="w-5 h-5 text-[#00E4BB]" data-id="element-1332" />
        </button>
      </div>
      {/* Sweet Greens Advertisement */}
      <div className="mb-4 rounded-2xl overflow-hidden relative" data-id="element-1333">
        <div className="bg-[#C0CA33] p-6 relative" data-id="element-1334">
          <div className="flex items-center" data-id="element-1335">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/scAvhsb3Y8BwMC8wHgqDfw/logo-branding-icon-qcb0z7xkdnwhni6kncu584o6jbzmcxiysh5nu4x4ao.png" alt="Sweet Greens" className="w-16 h-16 rounded-full mr-4" data-id="element-1336" />
            <div data-id="element-1337">
              <h3 className="text-[#1A237E] font-bold text-xl font-gt-ultra" data-id="element-1338">
                Sweet Greens x Smart Soda
              </h3>
              <p className="text-[#1A237E]/80 font-gill-sans" data-id="element-1339">
                Free Smart Soda with every salad purchase
              </p>
            </div>
          </div>
          <Button className="mt-4" variant="secondary" data-id="element-1340">
            Claim Offer
          </Button>
        </div>
      </div>
      {/* View toggle */}
      <div className="flex bg-[#FAFAFA]/10 border border-[#00E4BB]/30 rounded-full p-1 mb-4" data-id="element-1341">
        <button className={`flex-1 py-2 rounded-full flex items-center justify-center ${viewMode === 'list' ? 'bg-[#00E4BB] text-[#1A237E]' : 'text-[#00E4BB]'}`} onClick={() => setViewMode('list')} data-id="element-1342">
          <ListIcon className="w-4 h-4 mr-1" data-id="element-1343" />
          List
        </button>
        <button className={`flex-1 py-2 rounded-full flex items-center justify-center ${viewMode === 'map' ? 'bg-[#00E4BB] text-[#1A237E]' : 'text-[#00E4BB]'}`} onClick={() => setViewMode('map')} data-id="element-1344">
          <CompassIcon className="w-4 h-4 mr-1" data-id="element-1345" />
          Map
        </button>
      </div>
      {viewMode === 'map' ? <div className="relative h-96 rounded-2xl overflow-hidden mb-6 bg-[#1A237E]/50" data-id="element-1346">
          <div className="absolute inset-0 flex items-center justify-center" data-id="element-1347">
            <div className="text-center" data-id="element-1348">
              <MapPinIcon className="w-12 h-12 text-[#00E4BB] mx-auto mb-2" data-id="element-1349" />
              <p className="text-white" data-id="element-1350">Map view would display here</p>
              <p className="text-sm text-gray-400" data-id="element-1351">
                Using native maps integration
              </p>
            </div>
          </div>
          {/* Location pins */}
          <div className="absolute top-1/4 left-1/3" data-id="element-1352">
            <div className="w-8 h-8 bg-[#00E4BB] rounded-full flex items-center justify-center animate-pulse" data-id="element-1353">
              <MapPinIcon className="w-5 h-5 text-[#1A237E]" data-id="element-1354" />
            </div>
          </div>
          <div className="absolute top-1/3 left-1/2" data-id="element-1355">
            <div className="w-10 h-10 bg-[#A6FF4D] rounded-full flex items-center justify-center ring-4 ring-[#A6FF4D]/30 animate-pulse" data-id="element-1356">
              <MapPinIcon className="w-6 h-6 text-[#1A237E]" data-id="element-1357" />
            </div>
          </div>
          <div className="absolute top-1/2 left-2/3" data-id="element-1358">
            <div className="w-8 h-8 bg-[#00E4BB] rounded-full flex items-center justify-center" data-id="element-1359">
              <MapPinIcon className="w-5 h-5 text-[#1A237E]" data-id="element-1360" />
            </div>
          </div>
          <div className="absolute top-3/4 left-1/2" data-id="element-1361">
            <div className="w-8 h-8 bg-[#00E4BB]/50 rounded-full flex items-center justify-center" data-id="element-1362">
              <MapPinIcon className="w-5 h-5 text-[#1A237E]" data-id="element-1363" />
            </div>
          </div>
          {/* Current location */}
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" data-id="element-1364">
            <div className="w-6 h-6 bg-blue-500 rounded-full border-2 border-white" data-id="element-1365"></div>
            <div className="absolute top-0 left-0 right-0 bottom-0 w-6 h-6 rounded-full bg-blue-500 opacity-30 animate-ping" data-id="element-1366"></div>
          </div>
        </div> : <div className="space-y-4" data-id="element-1367">
          {/* Featured Location */}
          {locations.filter(loc => loc.isFeatured).map(location => <GlassCard key={location.id} className="p-4 border-2 border-[#A6FF4D]" data-id="element-1368">
                <div className="flex justify-between" data-id="element-1369">
                  <div data-id="element-1370">
                    <div className="flex items-center" data-id="element-1371">
                      <h3 className="text-white font-medium font-gt-ultra" data-id="element-1372">
                        {location.name}
                      </h3>
                      <span className="ml-2 text-xs bg-[#A6FF4D]/20 text-[#A6FF4D] px-2 py-0.5 rounded-full" data-id="element-1373">
                        Popular
                      </span>
                    </div>
                    <p className="text-sm text-gray-300 font-gill-sans" data-id="element-1374">
                      {location.address}
                    </p>
                    {/* Special Offer */}
                    <div className="mt-2 p-3 bg-[#00E4BB]/10 rounded-lg" data-id="element-1375">
                      <p className="text-[#00E4BB] text-sm font-medium" data-id="element-1376">
                        Community Hub:
                      </p>
                      <p className="text-white text-sm" data-id="element-1377">
                        {location.specialOffer}
                      </p>
                      <Button size="sm" className="mt-2 bg-[#A6FF4D] text-[#1A237E] border-none" data-id="element-1378">
                        Join Event
                      </Button>
                    </div>
                    <div className="flex mt-2 space-x-2" data-id="element-1379">
                      {location.isOpen ? <span className="text-xs bg-green-500/20 text-green-400 px-2 py-0.5 rounded-full" data-id="element-1380">
                          Open Now
                        </span> : <span className="text-xs bg-red-500/20 text-red-400 px-2 py-0.5 rounded-full" data-id="element-1381">
                          Closed
                        </span>}
                      {location.hasFreeRefills && <span className="text-xs bg-[#A6FF4D]/20 text-[#A6FF4D] px-2 py-0.5 rounded-full" data-id="element-1382">
                          Free Refills
                        </span>}
                    </div>
                  </div>
                  <div className="flex flex-col items-end" data-id="element-1383">
                    <span className="text-[#00E4BB] font-medium" data-id="element-1384">
                      {location.distance}
                    </span>
                    <div className="flex flex-col space-y-2 mt-2" data-id="element-1385">
                      <Button size="sm" data-id="element-1386">Directions</Button>
                      <Button size="sm" className="bg-[#A6FF4D] text-[#1A237E] border-none" data-id="element-1387">
                        Check In
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="mt-3" data-id="element-1388">
                  <p className="text-xs text-gray-400" data-id="element-1389">Available flavors:</p>
                  <div className="flex flex-wrap mt-1 gap-2" data-id="element-1390">
                    {location.flavors.map((flavor, idx) => <span key={idx} className="text-xs bg-[#00E4BB]/10 text-[#00E4BB] px-2 py-0.5 rounded-full" data-id="element-1391">
                        {flavor}
                      </span>)}
                  </div>
                </div>
              </GlassCard>)}
          {/* Other Locations */}
          {locations.filter(loc => !loc.isFeatured).map(location => <GlassCard key={location.id} className="p-4" data-id="element-1392">
                <div className="flex justify-between" data-id="element-1393">
                  <div data-id="element-1394">
                    <h3 className="text-white font-medium font-gt-ultra" data-id="element-1395">
                      {location.name}
                    </h3>
                    <p className="text-sm text-gray-300 font-gill-sans" data-id="element-1396">
                      {location.address}
                    </p>
                    {/* Special Offer */}
                    <div className="mt-2 p-3 bg-[#00E4BB]/10 rounded-lg" data-id="element-1397">
                      <p className="text-[#00E4BB] text-sm font-medium" data-id="element-1398">
                        Special Offer:
                      </p>
                      <p className="text-white text-sm" data-id="element-1399">
                        {location.specialOffer}
                      </p>
                      <Button size="sm" variant="outline" className="mt-2 border-[#00E4BB]/30" data-id="element-1400">
                        Claim Offer
                      </Button>
                    </div>
                    <div className="flex mt-2 space-x-2" data-id="element-1401">
                      {location.isOpen ? <span className="text-xs bg-green-500/20 text-green-400 px-2 py-0.5 rounded-full" data-id="element-1402">
                          Open Now
                        </span> : <span className="text-xs bg-red-500/20 text-red-400 px-2 py-0.5 rounded-full" data-id="element-1403">
                          Closed
                        </span>}
                      {location.hasFreeRefills && <span className="text-xs bg-[#A6FF4D]/20 text-[#A6FF4D] px-2 py-0.5 rounded-full" data-id="element-1404">
                          Free Refills
                        </span>}
                    </div>
                  </div>
                  <div className="flex flex-col items-end" data-id="element-1405">
                    <span className="text-[#00E4BB] font-medium" data-id="element-1406">
                      {location.distance}
                    </span>
                    <div className="flex flex-col space-y-2 mt-2" data-id="element-1407">
                      <Button size="sm" data-id="element-1408">Directions</Button>
                      <Button size="sm" variant="outline" className="border-[#00E4BB]/30" data-id="element-1409">
                        Check In
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="mt-3" data-id="element-1410">
                  <p className="text-xs text-gray-400" data-id="element-1411">Available flavors:</p>
                  <div className="flex flex-wrap mt-1 gap-2" data-id="element-1412">
                    {location.flavors.map((flavor, idx) => <span key={idx} className="text-xs bg-[#00E4BB]/10 text-[#00E4BB] px-2 py-0.5 rounded-full" data-id="element-1413">
                        {flavor}
                      </span>)}
                  </div>
                </div>
              </GlassCard>)}
        </div>}
      {viewMode === 'map' && <div className="mt-4" data-id="element-1414">
          <h3 className="text-white font-medium mb-2 font-gt-ultra" data-id="element-1415">
            Nearest Locations
          </h3>
          <GlassCard className="p-3 border-l-4 border-l-[#A6FF4D]" data-id="element-1416">
            <div className="flex items-center" data-id="element-1417">
              <div className="w-10 h-10 bg-[#A6FF4D]/20 rounded-lg flex items-center justify-center mr-3" data-id="element-1418">
                <MapPinIcon className="w-5 h-5 text-[#A6FF4D]" data-id="element-1419" />
              </div>
              <div className="flex-1" data-id="element-1420">
                <h4 className="text-white text-sm font-medium" data-id="element-1421">
                  Hydration Lounge at One Health Clubs
                </h4>
                <p className="text-xs text-gray-300" data-id="element-1422">
                  0.5 mi • Open Now • Community Hub
                </p>
              </div>
              <Button size="sm" className="bg-[#A6FF4D] text-[#1A237E] border-none" data-id="element-1423">
                Go
              </Button>
            </div>
          </GlassCard>
          <GlassCard className="p-3 mt-2" data-id="element-1424">
            <div className="flex items-center" data-id="element-1425">
              <div className="w-10 h-10 bg-[#00E4BB]/20 rounded-lg flex items-center justify-center mr-3" data-id="element-1426">
                <MapPinIcon className="w-5 h-5 text-[#00E4BB]" data-id="element-1427" />
              </div>
              <div className="flex-1" data-id="element-1428">
                <h4 className="text-white text-sm font-medium" data-id="element-1429">Eco Café</h4>
                <p className="text-xs text-gray-300" data-id="element-1430">0.3 mi • Open Now</p>
              </div>
              <Button size="sm" data-id="element-1431">Go</Button>
            </div>
          </GlassCard>
        </div>}
      {/* New Members Section */}
      <div className="mt-6" data-id="element-1432">
        <h3 className="text-white font-medium mb-3 font-gt-ultra" data-id="element-1433">
          Recently Joined Members
        </h3>
        <div className="space-y-3" data-id="element-1434">
          {[{
          name: 'Alex M.',
          location: 'Eco Café',
          joinedTime: '2 hours ago',
          avatar: 'https://i.pravatar.cc/100?img=3'
        }, {
          name: 'Jamie T.',
          location: 'Fitness Center',
          joinedTime: '5 hours ago',
          avatar: 'https://i.pravatar.cc/100?img=4'
        }, {
          name: 'Taylor K.',
          location: 'Hydration Lounge',
          joinedTime: 'Today',
          avatar: 'https://i.pravatar.cc/100?img=5'
        }].map((member, index) => <GlassCard key={index} className="p-3 flex items-center" data-id="element-1435">
              <img src={member.avatar} alt={member.name} className="w-10 h-10 rounded-full mr-3" data-id="element-1436" />
              <div className="flex-1" data-id="element-1437">
                <h4 className="text-white text-sm font-medium" data-id="element-1438">
                  {member.name}
                </h4>
                <p className="text-xs text-gray-300" data-id="element-1439">
                  Joined {member.location} • {member.joinedTime}
                </p>
              </div>
              <Button size="sm" variant="outline" className="border-[#00E4BB]/30 text-[#00E4BB] text-xs" data-id="element-1440">
                Connect
              </Button>
            </GlassCard>)}
        </div>
      </div>
    </div>;
};
export default SodaLocator;